import type { ThresholdStep } from '../api/types';

/**
 * Evaluate a value against a set of threshold steps and return the matching color.
 * Steps are expected in ascending order of `value`. The last step whose value
 * is <= the given value wins.
 */
export function evaluateThreshold(
  value: number | null | undefined,
  steps: ThresholdStep[],
): string {
  if (value === null || value === undefined || !Number.isFinite(value) || !steps.length) {
    return steps[0]?.color ?? '#888';
  }

  let color = steps[0].color;
  for (const step of steps) {
    if (step.value === null) continue;
    if (value >= step.value) {
      color = step.color;
    }
  }
  return color;
}

/**
 * Map Grafana color names to hex codes matching the Kyndryl theme.
 */
export function resolveThresholdColor(name: string): string {
  const map: Record<string, string> = {
    green: '#4CDD84',
    yellow: '#FFCB47',
    orange: '#FF9830',
    red: '#FF462D',
    blue: '#29707A',
  };
  if (name.startsWith('#')) return name;
  return map[name] ?? name;
}
